import isVerifyTokenGuard from "@/guards/verifyTokenGuard";

export default {
    name: 'special-labels',
    component: () => import(/* webpackChunkName: "base-layout" */ '@/layouts/BaseLayout.vue'),
    children: [
        {
            path: '',
            name: 'special-labels-index',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [                    
                    {                           
                        transKey: 'breadcrumbs.special-labels-index',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "special-labels-index" */ '@/modules/configurations/catalogs/special-labels/views/Index.vue')
        },
        {
            path: 'create',
            name: 'special-labels-create',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [
                    {   
                        route: {
                            name: 'special-labels-index',
                            params: {}
                        },
                        transKey: 'breadcrumbs.special-labels-index',
                        isActive: false
                    },
                    {                           
                        transKey: 'breadcrumbs.special-labels-create',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "special-labels-create" */ '@/modules/configurations/catalogs/special-labels/views/Create.vue')
        },
        {
            path: 'edit/:id',
            name: 'special-labels-edit',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [
                    {   
                        route: {
                            name: 'special-labels-index',
                            params: {}
                        },
                        transKey: 'breadcrumbs.special-labels-index',
                        isActive: false
                    },
                    {                           
                        transKey: 'breadcrumbs.special-labels-edit',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "special-labels-edit" */ '@/modules/configurations/catalogs/special-labels/views/Edit.vue')
        }
    ]
}